import React, { useState } from "react";
import BrandWordmark from "../../Common/BrandWordmark";
import Avtar from "../../../asset/new/images/user_login.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../../Redux/Slices/AuthSlice";
import { IoExitOutline } from "react-icons/io5";
import { FaUser, FaChevronDown, FaBars } from "react-icons/fa";
import { TfiHelpAlt } from "react-icons/tfi";
import { MdDashboard } from "react-icons/md";
import NotificationBell from "../../Common/NotificationBell";
import "../../../asset/new/css/admin-modern.css";

const AdminNavbar = ({ onToggleSidebar = () => {} }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const name = localStorage.getItem("name");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const log = () => {
    dispatch(logout());
    navigate("/signin");
  };

  const getInitials = (name) => {
    if (!name) return "AD";
    const words = name.split(" ");
    return words.map((word) => word[0]).join("").toUpperCase().slice(0, 2);
  };

  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-container">
        <div className="admin-flex admin-items-center" style={{ gap: 0 }}>
          <Link className="admin-navbar-logo" to="/">
            <BrandWordmark variant="navbar" />
          </Link>

          <button
            className="admin-btn-icon admin-btn-ghost d-lg-none"
            onClick={onToggleSidebar}
            aria-label="Toggle sidebar"
            style={{ marginLeft: "var(--spacing-md)" }}
          >
            <FaBars />
          </button>
        </div>

        <div className="admin-navbar-right">
          <NotificationBell variant="admin" />

          <div style={{ position: "relative" }}>
            <button
              className="admin-navbar-user"
              onClick={() => setDropdownOpen(!dropdownOpen)}
              aria-expanded={dropdownOpen}
            >
              <div className="admin-navbar-avatar">
                {Avtar ? (
                  <img src={Avtar} alt={name || "User"} />
                ) : (
                  getInitials(name)
                )}
              </div>
              <div className="admin-navbar-user-info">
                <div className="admin-navbar-user-name">{name || "Admin"}</div>
                <div className="admin-navbar-user-role">Administrator</div>
              </div>
              <FaChevronDown size={12} style={{ color: "var(--admin-text-muted)" }} />
            </button>

            {dropdownOpen && (
              <>
                <div
                  className="admin-navbar-overlay"
                  onClick={() => setDropdownOpen(false)}
                />
                <div className="admin-navbar-dropdown" style={{ zIndex: 1001 }}>
                  <Link
                    to="/admin/profile"
                    className="admin-navbar-dropdown-item"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <FaUser /> My Profile
                  </Link>
                  <Link
                    to="/admin/dashboard"
                    className="admin-navbar-dropdown-item"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <MdDashboard /> Dashboard
                  </Link>
                  <Link
                    to="/contact"
                    className="admin-navbar-dropdown-item"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <TfiHelpAlt /> Help Center
                  </Link>
                  <div className="admin-navbar-dropdown-divider" />
                  <button
                    onClick={() => {
                      setDropdownOpen(false);
                      log();
                    }}
                    className="admin-navbar-dropdown-item logout-btn"
                  >
                    <IoExitOutline /> Log Out
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
